import styled from "@emotion/styled";
import { DETAIL_HEADER_ASPECT_RATIO } from "~/components/stores/detail-product/style";

export const DivSampleImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const PictureSampleImagePosition = styled.picture`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;

  ::before {
    content: "";
    display: block;
    width: 100%;
    padding-top: ${DETAIL_HEADER_ASPECT_RATIO}%;
  }
`;

export const CustomImage = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
